import { Box, CircularProgress } from '@mui/material';

import { LOADING_BOX_STYLES } from '../styles/universal-location-map.styles';

export interface MapLoadingStateProps {
  height: string | number;
  className?: string;
  style?: React.CSSProperties;
  loadingText: string;
}

export function MapLoadingState({ height, className, style, loadingText }: MapLoadingStateProps) {
  const boxStyles = { ...LOADING_BOX_STYLES, height, ...style };

  return (
    <Box className={className} sx={boxStyles}>
      <CircularProgress />
      <Box ml={2}>{loadingText}</Box>
    </Box>
  );
}
